import axios from "axios";
import {toastr} from "react-redux-toastr";

const API = axios.create({
    baseURL: process.env.REACT_APP_API,
    timeout: 600000,
});

API.interceptors.request.use(
    (config) => {
        let jwt = localStorage.getItem('jwt');
        if (jwt) {
            let jwtMFA = localStorage.getItem('jwtMFA');
            if (jwtMFA) {
                config.headers.Authorization = `Bearer ${jwt} ${jwtMFA}`;
            }else {
                config.headers.Authorization = `Bearer ${jwt}`;
            }
        }

        return config;
    },
    (error) => {
        console.log(error);
        return Promise.reject(error);
    }
);

API.interceptors.response.use(response => {
    return response;
}, error => {
    if (error.response.status === 401) {
        let refreshPage = false;

        console.log(error?.response?.data);

        if (error?.response?.data?.NeedMFATokenRefresh === 1) {
            localStorage.removeItem('jwtMFA');
            refreshPage = true;
        }
        if (error?.response?.data?.NeedTokenRefresh === 1) {
            localStorage.removeItem('jwt');
            refreshPage = true;
        }

        if (refreshPage) {
            localStorage.removeItem('user');
            window.location.reload();
        }else {
            return Promise.reject(error);
        }
    }else {
        if (error?.response?.status === 500) {
            toastr.error('Error', 'An error occurred. Please try again later.');
        }else if (error?.response?.status === 422) {
            //422 error message
            toastr.error('Error', error?.response?.data?.data?.message ?? 'An error occurred. Please try again later.');
        }
        return Promise.reject(error);
    }
});

export default API;
